import { render, staticRenderFns } from "./ManualDiscount.vue?vue&type=template&id=071f8af2&scoped=true&"
import script from "./ManualDiscount.vue?vue&type=script&lang=js&"
export * from "./ManualDiscount.vue?vue&type=script&lang=js&"
import style0 from "./ManualDiscount.vue?vue&type=style&index=0&id=071f8af2&lang=scss&scoped=true&"
import style1 from "./ManualDiscount.vue?vue&type=style&index=1&id=071f8af2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071f8af2",
  null
  
)

export default component.exports